import { InjectionToken } from '@angular/core';
import { SearchService } from '../../../../shared/services/search.service';

export const EquipmentSearchService = new InjectionToken<SearchService>('EquipmentSearchService');
